<template>
  <fragment>
    <c-hero-full class="illustration-section-01" />
    <c-features-tiles class="illustration-section-02" />
    <c-features-split invert-mobile top-divider class="illustration-section-03" />
    <c-cta top-divider class="illustration-section-04" />
  </fragment>
</template>

<script>
// import layout
import CLayout from '@/layouts/LayoutDefault.vue';
// import sections
import CHeroFull from '@/components/sections/HeroFull.vue';
import CFeaturesTiles from '@/components/sections/FeaturesTiles.vue';
import CFeaturesSplit from '@/components/sections/FeaturesSplit.vue';
import CCta from '@/components/sections/Cta.vue';

export default {
  name: 'Home',
  components: {
    CHeroFull,
    CFeaturesTiles,
    CFeaturesSplit,
    CCta
  },
  created() {
    this.$emit('update:layout', CLayout);
  }
};
</script>
